/**
 *
 * DentistOverviewPage
 *
 */

import { createRef, Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import AppContainer from "components/AppContainer/AppContainer";
import GlobalMessages from "messages/messages";
import ForegroundBlobFakeModalHeader from "basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import History from "utils/history";
import ForegroundBlob from "basicComponents/ForegroundBlob/ForegroundBlob";
import * as PropTypes from "prop-types";
import DentistOverview from "components/DentistOverview/DentistOverview";
import messages from "./messages";
import { makeSelectPractice } from "../PracticePage/selectors";
import Pagination from "../../basicComponents/Pagination/Pagination";
import { getPractice } from "../../utils/practiceStorage";
import {
  createDentistAction,
  resetDentists,
  deleteDentistAction,
  resetDentistDeleteMessage,
} from "../App/actions";
import {
  makeSelectDentistDeleted,
  makeSelectDentistDeleteFailed,
  makeSelectDentistDeleteLoading,
} from "../App/selectors";

export class DentistOverviewPage extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
    resetDentists: PropTypes.func.isRequired,
    dentistDeleteFailed: PropTypes.object,
    deleteDentistLoading: PropTypes.bool,
    onDentistMessageReset: PropTypes.func,
    deleteDentist: PropTypes.func,
    dentistDeleted: PropTypes.bool,
  };

  state = {
    filter: "",
    result: [],
  };
  constructor(props) {
    super(props);
    this.paginationRef = createRef();
  }

  componentWillUnmount() {
    this.props.onDentistMessageReset();
  }

  handleDentistFilterChanged = () => {
    // After creating a new Dentist it will be shown in the list.
    if (this.paginationRef.current === null) {
      return;
    }
    this.paginationRef.current.update();
  };

  handleClose = () => {
    this.props.resetDentists();
    History.push("/dashboard");
  };

  handleResult = result => {
    this.setState({ result });
  };
  handleChange = e => {
    this.setState({ filter: e.target.value });
  };

  render() {
    return (
      <div>
        <AppContainer
          header={<FormattedMessage {...messages.header} />}
          color="blue"
        >
          <ForegroundBlob fullscreen>
            <ForegroundBlobFakeModalHeader
              noPadding
              noUnderline
              onClose={this.handleClose}
            >
              <div data-cy="headerDentists">
                <FormattedMessage {...GlobalMessages.dentist_overview_large} />
              </div>
            </ForegroundBlobFakeModalHeader>
            <DentistOverview
              deleteDentist={this.props.deleteDentist}
              createDentist={this.props.createDentist}
              onFilter={this.handleDentistFilterChanged}
              initialInputText={History.location.searchText || ""}
              onChange={this.handleChange}
              showTableContent
              value={this.state.filter}
              items={this.state.result}
              practice={this.props.practice}
              showArrow={false}
              height={460}
              failedDeleteMessage={this.props.dentistDeleteFailed}
              dentistDeleted={this.props.dentistDeleted}
            />
            <Pagination
              url={`/practices/${getPractice().id}/dentists/pagination/filter`}
              filter={this.state.filter}
              limit={10}
              handleResult={this.handleResult}
              ref={this.paginationRef}
            />
          </ForegroundBlob>
        </AppContainer>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  practice: makeSelectPractice(),
  dentistDeleteFailed: makeSelectDentistDeleteFailed(),
  deleteDentistLoading: makeSelectDentistDeleteLoading(),
  dentistDeleted: makeSelectDentistDeleted(),
});

function mapDispatchToProps(dispatch) {
  return {
    createDentist: (dentist, callback, existing) =>
      dispatch(createDentistAction(dentist, callback, existing)),
    resetDentists: () => dispatch(resetDentists()),
    deleteDentist: dentist => dispatch(deleteDentistAction(dentist)),
    onDentistMessageReset: () => dispatch(resetDentistDeleteMessage()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(DentistOverviewPage);
